import React from "react";
import urls from "../Utils/urls";
import "../css/service.css";
import "../css/serviceAnim.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  AnimQuickApproval,
  AnimQuickPaperwork,
  AnimDigitalApply,
  AnimFlexible,
  AnimRepayment,
  AnimCollateralFree,
} from "../components/ServiceAnimations";

const SERVICES = [
  {
    anim: AnimQuickApproval, badge: "01", tag: "FAST & RELIABLE",
    title: "Quick Approval",
    desc: "At Salary Uncle, we offer fast loan approvals — often within minutes. Our AI-powered system evaluates your application instantly so you never have to wait.",
    points: ["Decision in under 10 minutes", "No manual review delays", "Real-time status updates"],
    reverse: false,
  },
  {
    anim: AnimQuickPaperwork, badge: "02", tag: "HASSLE-FREE",
    title: "Quick Paperwork",
    desc: "Personal loans with minimal paperwork — simpler than traditional banks. Just 3 documents and you're done. No stacks of forms, no branch visits.",
    points: ["Only Aadhaar, PAN & salary slip", "Digital document upload", "Auto-verification in seconds"],
    reverse: true,
  },
  {
    anim: AnimDigitalApply, badge: "03", tag: "100% DIGITAL",
    title: "Digital Application",
    desc: "Salary Uncle lets you apply online — anytime, anywhere. Our fully digital process means you go from application to approval without ever leaving your home.",
    points: ["Apply from your smartphone", "Available 24/7 — no office hours", "Instant confirmation via SMS & email"],
    reverse: false,
  },
  {
    anim: AnimFlexible, badge: "04", tag: "FLEXIBLE TERMS",
    title: "Loan Your Way",
    desc: "Short-term loans offer flexible eligibility and faster approvals. Choose the amount and tenure that fits your needs — from ₹5,000 to ₹1,00,000.",
    points: ["₹5,000 to ₹1,00,000 loan range", "1 to 60 day flexible tenure", "Customised repayment plan"],
    reverse: true,
  },
  {
    anim: AnimRepayment, badge: "05", tag: "EASY REPAYMENT",
    title: "Payback Time",
    desc: "Repay personal loans within 7 to 60 days. Multiple repayment options including UPI, net banking, and auto-debit make it completely stress-free.",
    points: ["UPI, net banking, auto-debit", "Zero prepayment penalty", "Reminders before due date"],
    reverse: false,
  },
  {
    anim: AnimCollateralFree, badge: "06", tag: "ZERO SECURITY",
    title: "Collateral-Free",
    desc: "Personal loans are unsecured — no need for collateral like a house or vehicle. Your salary is your qualification. Nothing else required.",
    points: ["No asset pledge required", "Based purely on salary profile", "100% unsecured lending"],
    reverse: true,
  },
];

const Services = () => (
  <>
    <Helmet>
      <title>Instant Salary Loans Online — Fast, Flexible & Secure</title>
      <meta property="og:title" content="Instant Salary Loans Online — Fast, Flexible & Secure" />
      <meta name="description" content="Get instant approval, minimal paperwork & secure salary loans online. Trusted by 10,000+ customers. No collateral required — Apply now with Salary Uncle." />
      <meta property="og:description" content="Get instant approval, minimal paperwork & secure salary loans online. Trusted by 10,000+ customers. No collateral required — Apply now with Salary Uncle." />
      <link rel="canonical" href={`${urls.SITE_URL}/services`} />
    </Helmet>

    {/* ── HERO ── */}
    <section className="sv-hero">
      <div className="sv-hero-inner">
        <span className="sv-hero-tag">OUR SERVICES</span>
        <h1>Instant Loans <span>You Can Trust</span></h1>
        <p>Quick, transparent salary loans for instant access to funds — your trusted financial partner for every need.</p>
        <div className="sv-hero-btns">
          <Link to="/apply-now" className="sv-hero-btn-primary">Apply Now &nbsp;→</Link>
          <Link to="/calculator" className="sv-hero-btn-outline">Calculator</Link>
        </div>
      </div>
      {/* floating stat pills */}
      <div className="sv-hero-pills">
        {["10 min Approval", "₹1L Max Loan", "100% Digital", "No Collateral"].map((t, i) => (
          <div className="sv-pill" key={i}>{t}</div>
        ))}
      </div>
    </section>

    {/* ── SERVICES — Alternating rows ── */}
    <section className="sv-services-section">
      <div className="sv-services-inner">
        <div className="sv-section-head">
          <span className="sv-section-tag">WHAT WE OFFER</span>
          <h2>Solutions That Match Your Financial Goals</h2>
          <p>Six powerful features that make Salary Uncle the smarter choice for salaried professionals.</p>
        </div>

        {SERVICES.map((s, i) => (
          <div className={`sv-row ${s.reverse ? "sv-row--reverse" : ""}`} key={i}>
            {/* Animation */}
            <div className="sv-row-img">
              <div className="sv-anim-wrap">
                {React.createElement(s.anim)}
                <div className="sv-img-badge">{s.badge}</div>
              </div>
            </div>

            {/* Content */}
            <div className="sv-row-content">
              <span className="sv-row-tag">{s.tag}</span>
              <h3 className="sv-row-title">{s.title}</h3>
              <p className="sv-row-desc">{s.desc}</p>
              <ul className="sv-row-points">
                {s.points.map((p, j) => (
                  <li key={j}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    {p}
                  </li>
                ))}
              </ul>
              <Link to="/apply-now" className="sv-row-btn">Apply Now &nbsp;→</Link>
            </div>
          </div>
        ))}
      </div>
    </section>

    {/* ── CTA ── */}
    <section className="sv-cta">
      <div className="sv-cta-inner">
        <span className="sv-cta-tag">GET STARTED TODAY</span>
        <h2>Ready for an Instant Loan?</h2>
        <p>Apply now and get your funds disbursed in as little as 10 minutes after approval.</p>
        <div className="sv-cta-btns">
          <Link to="/apply-now" className="sv-btn-primary">Apply Now</Link>
          <Link to="/contact" className="sv-btn-outline">Contact Us</Link>
        </div>
      </div>
    </section>
  </>
);

export default Services;
